<mat-sidenav-container class="menu-container" fullscreen>
  <div [ngClass]="{ 'shift-menu-bar-trigger': isMobileViewOpen }" class="menu-bar-trigger">
    <app-arrow-button-box
      (click)="isMobileViewOpen = !isMobileViewOpen"
      [direction]="isMobileViewOpen ? 'left' : 'right'"
      thickness="light"
    ></app-arrow-button-box>
    <!--      [isFilled]="isMobileViewOpen"-->
    <!--    <button (click)="isMobileViewOpen = !isMobileViewOpen" class="btn-small" mat-button>-->
    <!--      <span class="icon-options"></span>-->
    <!--    </button>-->
  </div>
  <mat-sidenav
    [disableClose]="true"
    [ngClass]="{ 'mobile-open': isMobileViewOpen }"
    class="menu-bar"
    mode="side"
    opened
  >
    <div class="menu-items">
      @if (user.isLoggedIn()) {
        <a [routerLink]="['/landing']" class="logo">
          <img src="assets/icons/buildevo_logo_white.svg" alt="Buildevo Logo" />
        </a>
      }

      @if (user.data) {
        <div class="menu-options">
          <div class="" [ngClass]="{ hidden: !user.isPaidAccount }">
            <a
              data-cy="menu-add-button"
              (click)="clearLineItems()"
              [ngClass]="{ hidden: !user.isPaidAccount, active: activeButton === MENU_PAGES.ADD }"
              class="btn icon"
              [matMenuTriggerFor]="createMenu"
            >
              <div class="flex flex-col items-center gap-0.5">
                <span class="icon-add-block-square"></span>
                <span class="text-color-white">Add</span>
              </div>
            </a>
            <mat-menu class="mat-menu-container open-below" #createMenu xPosition="after" yPosition="below">
              <button data-cy="menu-add-activity" (click)="openActivitySidebar()" class="menu-btn" mat-menu-item>
                Add Daily Activity
              </button>
              <button data-cy="menu-add-project" (click)="openProjectSetup()" class="menu-btn" mat-menu-item>
                Add Project
              </button>
            </mat-menu>
          </div>
          @if (user.isPaidAccount) {
            <a
              (click)="setActive(MENU_PAGES.ACTIVITIES)"
              [routerLink]="['/webapp/activities']"
              class="btn icon"
              [ngClass]="{ active: activeButton === MENU_PAGES.ACTIVITIES }"
            >
              <div class="flex flex-col items-center gap-0.5">
                <span class="icon-activities items-center"></span>
                <span class="text-color-white">Activities</span>
              </div>
            </a>
          }
          <a
            (click)="setActive(MENU_PAGES.PROJECTS)"
            [routerLink]="['/webapp/projects']"
            class="btn icon"
            [ngClass]="{ active: activeButton === MENU_PAGES.PROJECTS }"
          >
            <div class="flex flex-col items-center gap-0.5">
              <span class="icon-projects"></span>
              <span class="text-color-white">Projects</span>
            </div>
          </a>
          <a
            (click)="setActive(MENU_PAGES.CASHFLOW)"
            [ngClass]="{
              hidden: !user.isPaidAccount,
              active: activeButton === MENU_PAGES.CASHFLOW,
            }"
            [routerLink]="['/webapp/cashflow']"
            class="btn icon"
          >
            <div class="flex flex-col items-center gap-0.5">
              <span class="icon-cashflow"></span>
              <span class="text-color-white">Cashflow</span>
            </div>
          </a>
          <a
            (click)="setActive(MENU_PAGES.CONTACTS)"
            matTooltipPosition="right"
            matTooltipClass="menu-tooltip"
            [ngClass]="{
              hidden: !user.isPaidAccount,
              active: activeButton === MENU_PAGES.CONTACTS,
            }"
            [routerLink]="['/webapp/contacts']"
            class="btn icon"
          >
            <div class="flex flex-col items-center gap-0.5">
              <span class="icon-service-providers"></span>
              <span class="text-color-white">Contacts</span>
            </div>
          </a>
          <a
            (click)="setActive(MENU_PAGES.DOCUMENTS)"
            matTooltipPosition="right"
            matTooltipClass="menu-tooltip"
            [routerLink]="['/webapp/documents']"
            class="btn icon"
            [ngClass]="{ active: activeButton === MENU_PAGES.DOCUMENTS }"
          >
            <div class="flex flex-col items-center gap-0.5">
              <span class="icon-drive"></span>
              <span class="text-color-white">Storage</span>
            </div>
          </a>
          @if (user.isPaidAccount) {
            <a
              class="btn icon"
              [matMenuTriggerFor]="reportingMenu"
              [ngClass]="{ active: activeButton === MENU_PAGES.PRINT }"
            >
              <div class="flex flex-col items-center gap-0.5">
                <span class="icon-print-report-2"></span>
                <span class="text-color-white">Reporting</span>
              </div>
            </a>
          }
          <mat-menu class="mat-menu-container open-below" #reportingMenu xPosition="after" yPosition="below">
            <button
              [ngClass]="{ disabled: disablePrintPage }"
              (click)="printPageReport()"
              class="menu-btn"
              mat-menu-item
            >
              Generate Page Report
            </button>
            <button (click)="openReports()" class="menu-btn" mat-menu-item>Generate Full Report</button>
            <button (click)="openInvoiceReports()" class="menu-btn" mat-menu-item>Invoice Log</button>
          </mat-menu>
        </div>
      }

      <div [ngClass]="{ invisible: !user.isLoggedIn() }" class="menu-options bottom-items">
        <a
          (click)="openDrawer(INTERACTION_BAR_STATES.NOTIFICATIONS)"
          [ngClass]="{ active: drawerState?.action === INTERACTION_BAR_STATES.NOTIFICATIONS }"
          class="btn"
          matTooltipPosition="right"
          matTooltipClass="menu-tooltip"
          [matTooltip]="'Notifications'"
        >
          <span class="icon-bell"></span>
          @if (
            (barState.notifCount | async) > 0 ||
            unreadStatus.has_unseen_notifications ||
            unreadStatus.has_pending_invitations
          ) {
            <div class="unread-bullet"></div>
          }
        </a>
        <a
          (click)="openMessages()"
          [ngClass]="{ active: drawerState?.action === INTERACTION_BAR_STATES.MESSAGES }"
          class="btn"
          matTooltipPosition="right"
          matTooltipClass="menu-tooltip"
          [matTooltip]="'Messages'"
        >
          <span class="icon-messages"></span>
          @if ((hasUnreadMessages$ | async) || unreadStatus.has_unread_messages) {
            <div class="unread-bullet"></div>
          }
        </a>
        <a
          (click)="openIntercom()"
          class="btn"
          matTooltipPosition="right"
          matTooltipClass="menu-tooltip"
          [matTooltip]="'Helpdesk and documentation'"
        >
          <span class="icon-question-mark"></span>
        </a>
        <button
          data-cy="settings-button"
          matTooltipPosition="right"
          [matTooltip]="user.isLoggedIn() ? 'Settings' : 'Authentication'"
          class="btn icon settings cursor-pointer"
          [matMenuTriggerFor]="settingsMenu"
        >
          @if (user.data ? user?.data?.profile_picture_url : false) {
            <div class="profile-pic">
              <img
                src="{{ user.data ? user?.data?.profile_picture_url : '' }}"
                [ngClass]="{ 'disp-none': picLoading }"
                (load)="profilePicLoaded()"
              />
              @if (picLoading) {
                <span class="icon-refresh animate-spin pic-loading"></span>
              }
            </div>
          }
          @if (user.isLoggedIn() && !user?.data?.profile_picture_url) {
            <span class="icon-settings"></span>
          }
          @if (!user.isLoggedIn()) {
            <span class="icon-logo-box-hex"></span>
          }
        </button>

        <mat-menu class="mat-menu-container settings" #settingsMenu="matMenu" xPosition="after" yPosition="above">
          @if (user.isLoggedIn() && user.isManager) {
            <a
              (click)="setActive(MENU_PAGES.SETTINGS)"
              [routerLink]="['/webapp/settings/properties']"
              class="menu-btn menu-property"
              mat-menu-item
            >
              <span class="menu-button-container">
                <span class="icon-properties"></span>
                <span> Properties </span>
              </span>
            </a>
          }
          @if (user.isPaidAccount && user.isLoggedIn()) {
            <a
              (click)="setActive(MENU_PAGES.SETTINGS)"
              [routerLink]="['/webapp/settings/teams']"
              class="menu-btn menu-property"
              mat-menu-item
            >
              <span class="menu-button-container">
                <span class="icon-team"></span>
                <span> Team </span>
              </span>
            </a>
          }
          @if (user.isPaidAccount && user.isLoggedIn()) {
            <a
              data-cy="templates-button"
              (click)="setActive(MENU_PAGES.SETTINGS)"
              [routerLink]="['/webapp/settings/templates']"
              class="menu-btn menu-property"
              mat-menu-item
            >
              <span class="menu-button-container">
                <span class="icon-templates"></span>
                <span> Templates </span>
              </span>
            </a>
          }
          @if (user.isLoggedIn()) {
            <a
              (click)="setActive(MENU_PAGES.SETTINGS)"
              [routerLink]="['/webapp/settings']"
              class="menu-btn menu-account"
              mat-menu-item
            >
              <span class="menu-button-container">
                <span class="icon-account"></span>
                <span> Account </span>
              </span>
            </a>
          }
          @if (user.isLoggedIn()) {
            <button data-cy="logout-button" (click)="logout()" class="menu-btn menu-logout" mat-menu-item>
              <span class="menu-button-container">
                <span class="icon-logout"></span>
                <span> Logout </span>
              </span>
            </button>
          }
          @if (!user.isLoggedIn()) {
            <button [routerLink]="['/auth/login']" class="menu-btn menu-logout" mat-menu-item>Login</button>
          }
          @if (!user.isLoggedIn()) {
            <button [routerLink]="['/auth/register']" class="menu-btn menu-logout" mat-menu-item>
              Register Account
            </button>
          }
        </mat-menu>
      </div>
    </div>
  </mat-sidenav>

  <ng-content></ng-content>
</mat-sidenav-container>
